<template>
    <div class="modal-dialog" :class="{expanded: uiStates.expandedView}">
        <div class="modal-content">
            <transition name="fade">
                <div class="choose-product" v-if="uiStates.showRelationProductSelector">
                    <div class="form-group">
                        <label for="selectProduct" class="">Select Matched Product</label>
                        <v-select
                            v-model="product.selectedRelatedProduct"
                            label="name"
                            :options="productMatches"
                            value="id"
                          ></v-select>
                    </div>
                    <div class="form-group">
                        <button v-on:click="uiStates.showRelationProductSelector = false" type="button" class="btn btn-default pull-right ml-1">Cancel</button>
                        <button :disabled="!product.selectedRelatedProduct" v-on:click="createRelationshipProduct(product, attributes)" type="button" class="btn btn-primary pull-right">
                            <span v-if="uiStates.showLoading"><i class="fa fa-spinner fa-pulse fa-fw"></i> Creating Item</span>
                            <span v-else>Create Product</span>
                        </button>
                    </div>
                </div>
            </transition>
            <div class="modal-header">
                <h4 class="modal-title">Create an Item</h4>
            </div>
            <div class="clearfix modal-body create-product-wizard" :class="{open: uiStates.expandedView, 'match-disabled': uiStates.matchPanelDisabled}">
                <transition name="fade">
                    <div class="form-container" :class="{'match-disabled': uiStates.matchPanelDisabled}">
                        <div class="form-group">
                            <label for="" class="">Vendor</label>
                            <v-select
                                v-model="selectedVendor"
                                label="name"
                                :options="vendors"
                                value="id"
                            ></v-select>
                         </div>
                         <div class="form-group">
                             <label for="" class="">Vendor Item Number</label>
                             <input type="text" class="form-control w-100" v-on:blur="addVendoritemToRelated()" v-model="vendorItemNumber.selectedValue.label">
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="" class="">Item Volume Capacity</label>
                                    <input type="text" class="form-control w-100" v-model="volumeSelector.volume">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="" class="">Unit of Measure</label>
                                    <v-select
                                        v-model="volumeSelector.selectedUnit"
                                        label="value"
                                        :options="unitsOfmeasurment"
                                        value="id"
                                    ></v-select>
                                </div>
                            </div>
                        </div>
                        <div v-for="attribute in attributes"  class="form-group">
                            <label for="productFilterEntityProperty" class="">{{attribute.name}}</label>
                            <v-select
                                label="label"
                                v-model="attribute.selectedValue"
                                @input="setAttribute(attribute)"
                                :clearable="true"
                                :options="attribute.typeValues"
                                :value="attribute.selectedValue"
                              ></v-select>
                              <div v-if="attribute.appendedAttributes.length > 0" v-for="childAttribute in attribute.appendedAttributes" class="child-attribute">
                                  <product-wizard-child :parent-active-attributes="childAttribute"></product-wizard-child>
                              </div>
                        </div>

                        <div class="form-group" v-if="uiStates.showProductname">
                            <div class="row">
                                <div class="col-md-12 mb-2">
                                    <hr>
                                    <label for="" class="">Product Name</label>
                                    <input v-model="product.name" type="text" class="form-control">
                                </div>
                                <div class="col-md-8">
                                    <label for="" class="">Product SKU</label>
                                    <input v-model="product.sku" type="text" class="form-control">
                                </div>
                                <div class="col-md-4">
                                    <button v-on:click="generateNameSku(attributes)" type="button" class="btn btn-generate-name btn-primary">Generate Name & Sku</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="match-panel">
                    <div  class="match-container">
                        <div class="match-heading">
                            Related Items
                        </div>
                        <ul v-if="productMatches.length !== 0" class="match-listing">
                            <li class="match-item" v-for="productMatch in productMatches">
                                <div class="clearfix">
                                    <a target="_blank" class="product-name" :href="'/products/'+productMatch.id+'/edit'">{{productMatchName(productMatch.name)}}</a>
                                    <a href="#"  data-toggle="collapse" v-on:click="toggleOpenState" :data-target="'#itemListing' + productMatch.id"  aria-expanded="false" class="show-snapshot"><i class="fa fa-chevron-down" aria-hidden="true"></i></a>
                                    <div class="percentage" v-bind:style="{color: setColor(productMatch.percentage)}">{{productMatch.percentage}}%</div>
                                </div>
                                <div class="collapse attribute-match-listing" :id="'itemListing'+ productMatch.id">
                                    <ul>
                                        <li v-for="attribute in productMatch.relatedAttributes">
                                            <a target="_blank" :href="'/attributes/'+attribute.id+'/edit'">{{attribute.name}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div class="no-related-found" v-else>
                            <div class="icon">
                                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                            </div>
                            <div class="copy">
                                No related products found.
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="clearfix modal-footer">
                <transition name="fade">
                    <div v-if="uiStates.errorMessage != ''" class="error-message pull-left"><i class="fa fa-times-circle" aria-hidden="true"></i> {{uiStates.errorMessage}}</div>
                </transition>
                <transition name="fade">
                    <div class="btn-group" v-if="product.hasMatch">
                      <button v-on:click="createProduct(product, attributes)" :disabled="product.name == ''" :class="[uiStates.errorMessage == '' ? 'btn-warning' : 'btn-danger']" class="btn">Create Child</button>
                          <button type="button" v-if="productRelationTypes.length !== 0"  :disabled="product.name == ''" class="btn dropdown-toggle dropdown-toggle-split"  :class="[uiStates.errorMessage == '' ? 'btn-warning' : 'btn-danger']" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                          </button>
                          <div class="dropdown-menu dropdown-menu-right">
                                <a v-for="(index, key) in productRelationTypes" class="dropdown-item" v-on:click="createProductRelationship(product, key)">Create  {{index}} Product</a>
                          </div>
                    </div>
                    <div v-else class="btn-group">
                        <button  v-on:click="createProduct(product, attributes)"  :disabled="product.name == ''" :class="[uiStates.errorMessage == '' ? 'btn-primary' : 'btn-danger']" class="btn">
                            <span v-if="uiStates.showLoading"><i class="fa fa-spinner fa-pulse fa-fw"></i> Creating Item</span>
                            <span v-else>Create Item</span>
                        </button>
                    </div>
                </transition>
                <a href="#" class="btn btn-default" data-dismiss="modal">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import axios from 'axios';
    import select2 from 'select2';
    import vSelect from 'vue-select';
    import childField from './product-wizard-child';

    Vue.use(VueEvents);

    export default {
        name: 'create-product-wizard',
        props: [],
        components:{
            'v-select': vSelect,
            'product-wizard-child': childField
        },
        data() {
            return {
                uiStates: {
                    expandedView: true,
                    matchPanelDisabled: false,
                    disableCreate: true,
                    errorMessage: '',
                    showLoading: false,
                    hasDuplicate: false,
                    showProductname: false,
                    showRelationProductSelector: false,
                },
                volumeSelector:{
                    volume: null,
                    selectedUnit: null,
                },
                selectedVendor: null,
                product: {
                    name: '',
                    sku: '',
                    hasMatch: false,
                    parentProductId: null,
                    productRelationshipTypeId: null,
                },
                productMatches: [],
                unitsOfmeasurment: [],
                vendorItemNumber: {
                    id:71,
                    name:"Vendor Item #",
					type: "text",
                    selectedValue: {
                        label: null,
                        type: "text",
                    },
                },
                vendors: [],
                lastSelection: null,
                attributes: [],
                combinedAttributes: [],
                productRelationTypes: [],
            }
        },
        watch: {
            uiStates: {
                handler(newValue, oldValue) {
                   $(".form-container").animate({ scrollTop: $(document).height() }, "slow");
                 },
                deep: true
            },
            attributes: {
                handler(newValue, oldValue) {
                   this.getRelatedProducts();
                   this.isReadyForName(this.attributes);
                 },
                deep: true
            },
            volumeSelector: {
                handler(newValue, oldValue) {
                   this.getRelatedProducts();
                 },
                deep: true
            },
            selectedVendor: {
                handler(newValue, oldValue) {
                   this.getRelatedProducts();
                 },
                deep: true
            },
        },
        mounted() {
            this.getUnitsOfMeasurement()
            this.getAttributes()
            this.getRelationshipType()
            this.uiStates.expandedView = true;
            this.uiStates.matchPanelDisabled = false;
        },
        methods: {
            addVendoritemToRelated() {
                this.getRelatedProducts();
            },
            setAttribute(thisAttribute) {
                this.uiStates.expandedView = true;
                this.uiStates.matchPanelDisabled = false;

                thisAttribute.appendedAttributes = [];

                if (thisAttribute.selectedValue == null) {
                    return;
                }

                if (thisAttribute.selectedValue.nestedAttributes) {
                    thisAttribute.appendedAttributes.push(thisAttribute.selectedValue.nestedAttributes);
                }else{
                    if (thisAttribute.selectedValue.nested_id !== null) {
                        this.getChild(thisAttribute.selectedValue);
                    }
                }
            },
            toggleOpenState () {
                $(event.target).toggleClass('open')
            },
            getChild (selected) {
                return axios.get('/products/wizard/attributes/'+ selected.nested_id, {
                })
                .then(function (response) {
                    this.child = response.data;
                    var childData = [];
                    childData[0] = response.data;
                    this.attributes.appendedAttributes = childData;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                }.bind(this));
            },
            loadNextAttribute () {
                console.log('value:');
            },
            createProduct (product, attributes) {
                this.uiStates.showLoading = true;
				let combinedAttributes = attributes.slice();
				combinedAttributes.push(this.vendorItemNumber);

                axios.post('/products/wizard/new', {
                    'name': product.name,
                    'sku': product.sku,
                    'product': product,
                    'parentId': product.parentProductId,
                    'attributes': combinedAttributes,
                    'volumeSelector': this.volumeSelector,
                    'selectedVendor': this.selectedVendor,
                })
                .then(function (response) {
                    window.location.href = response.data;
                }.bind(this))
                .catch(function (error) {
                    if (error.response.status == 422){
                        this.uiStates.errorMessage = error.response.data.errors.sku[0];
                    } else{
                        this.uiStates.errorMessage = error.response.data.message;
                    }
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            createRelationshipProduct (product, attributes) {
                this.uiStates.showLoading = true;
				let combinedAttributes = attributes.slice();
				combinedAttributes.push(this.vendorItemNumber);

                axios.post('/products/wizard/new', {
                    'name': product.name,
                    'sku': product.sku,
                    'product': product,
                    'attributes': combinedAttributes,
                    'volumeSelector': this.volumeSelector,
                    'selectedVendor': this.selectedVendor,
                })
                .then(function (response) {
                    window.location.href = response.data;
                }.bind(this))
                .catch(function (error) {
                    if (error.response.status == 422){
                        this.uiStates.errorMessage = error.response.data.errors.sku[0];
                    } else{
                        this.uiStates.errorMessage = error.response.data.message;
                    }
                    this.uiStates.showLoading = false;
                }.bind(this));
            },
            getAttributes () {
                axios.get('/products/wizard/attributes')
                .then(function (response) {
                    this.attributes = response.data;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.uiStates.errorMessage = 'Failed to retrieve attributes';
                }.bind(this));
            },
            getUnitsOfMeasurement () {
                axios.get('/products/wizard/get-units')
                .then(function (response) {
                    this.unitsOfmeasurment = response.data.units;
                    this.vendors = response.data.vendors;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.uiStates.errorMessage = 'Failed to retrieve attributes';
                }.bind(this));
            },
            getRelatedProducts () {
				let combinedAttributes = this.attributes.slice();
				combinedAttributes.push(this.vendorItemNumber);
                axios.post('/products/wizard/related', {
                    'relatedAttributes': combinedAttributes,
                    'volumeSelector': this.volumeSelector,
                    'selectedVendor': this.selectedVendor,
                })
                .then(function (response) {
                    this.productMatches = response.data.relatedProducts;
                    this.product.parentProductId = response.data.productId;
                    this.product.hasMatch = response.data.hasMatch;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.uiStates.errorMessage = 'Failed to retrieve related fields';
                }.bind(this));
            },
            getRelationshipType () {
                axios.get('/products/wizard/relationship-types', {

                })
                .then(function (response) {
                    this.productRelationTypes = response.data;
                }.bind(this))
                .catch(function (error) {
                    console.log(error);
                    this.uiStates.errorMessage = 'Failed to retrieve product relation types';
                }.bind(this));
            },
            createProductRelationship (product, relationshiptId) {
                this.product.productRelationshipTypeId = relationshiptId;
                this.uiStates.showRelationProductSelector = true;
                console.log(product);
                console.log(relationshiptId);
            },
            setColor (percentage) {
                var hue = percentage * 1.2 / 360;
                var rgb = this.hslToRgb(hue, 1, .4);
                return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
            },
            hslToRgb(h, s, l){
                var r, g, b;

                if(s == 0){
                    r = g = b = l;
                }else{
                    function hue2rgb(p, q, t){
                        if(t < 0) t += 1;
                        if(t > 1) t -= 1;
                        if(t < 1/6) return p + (q - p) * 6 * t;
                        if(t < 1/2) return q;
                        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
                        return p;
                    }

                    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                    var p = 2 * l - q;
                    r = hue2rgb(p, q, h + 1/3);
                    g = hue2rgb(p, q, h);
                    b = hue2rgb(p, q, h - 1/3);
                }

                return [Math.floor(g * 255), Math.floor(r * 255), Math.floor(b * 255)];
            },
            isReadyForName(array){
                var hasEmptyValues = true;

                for (var i = 0; i < array.length; i++) {
                    hasEmptyValues = true;

                    if ('selectedValue' in array[i]){
                        hasEmptyValues = false;

                    }
                }

                if (!hasEmptyValues) {
                    this.uiStates.showProductname = true;
                }
                // @TODO: Not working, needs investigation.
                // var allTrue = Object.keys(array).every(function(k){
                //     return 'selectedValue' in array;
                // });

                return null;
            },
            findObjectByKey(array, key, value){
               for (var i = 0; i < array.length; i++) {
                   if (array[i][key] === value) {
                        var foundArray = array[i];
                            foundArray.index = i
                       return foundArray;
                   }
               }
               return null;
            },
            checkObjectExists(array, key, value){
               for (var i = 0; i < array.length; i++) {
                   if (array[i][key] === value) {
                       return false;
                   }
               }
               return true;
            },
            productMatchName(name){
                if (name.length > 30) {
                    return name.substring(0,26)+'...';
                }
                return name;
            },
            generateNameSku (attributes) {
                this.uiStates.showLoading = true;

                axios.post('/products/wizard/generatenamesku', {
                    'activeAttributes': attributes,
                })
                .then(function (response) {
                    console.log(response.data.name);
                    this.product.name = response.data.name;
                    this.product.sku = response.data.sku;
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = 'An error has occured!';
                }.bind(this));
            },
        },
    };
</script>

<style lang="scss">
    .v-select .form-control{
        height: 30px !important;
    }
</style>

<style scoped="" lang="scss">
.choose-product{
    position: absolute;
    z-index: 4;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255,255,255, 0.9);
    padding : 190px 226px;
}
    .dropdown-toggle-split{
        border-left: 1px solid white;
        padding-bottom: 13px;
        z-index: 3;
        &:hover,
        &:active,
        &:focus{
            padding-left: 1px solid white;
            z-index:3;
        }
    }
    .v-select.form-control{
        height: 30px !important;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }

    .sku-display{
        margin-top: 5px;
    }
    .error-message{
        position: absolute;
        left: 35px;
        color: #ec644b;
    }
    .modal-footer{
        position: relative;
    }
    .btn{
        transition:all 0.5s;
    }
    .btn-primary i{
        margin-right:5px;
    }
    .create-product-wizard{
        position: relative;
        .form-container{
            transition: width 0.5s;
            position: absolute;
            top: 0;
            left:0;
            bottom: 0;
            padding:20px 25px;
            height: 121px;
            width: 100%;
            overflow-y: auto;
            &.match-disabled{
                overflow-y: initial;
            }
            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(0,0,0,0.1);
                position: absolute;
                top: 0px;
                bottom: 0px;
                right: 0px;
            }
            &::-webkit-scrollbar-thumb {
                background: #25628F;
                border-radius:2px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #25628F;
            }
        }
        .match-container{
            transition: width 0.5s;
            position: absolute;
            top: 0;
            right:0;
            bottom: 0;
            height: 120px;
            width: 0%;
            animation: opacity 0.8s;
            border-left:1px solid #dee0e1;
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                width: 4px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(0,0,0,0.1);
                position: absolute;
                top: 0px;
                bottom: 0px;
                right: 0px;
            }
            &::-webkit-scrollbar-thumb {
                background: #25628F;
                border-radius:2px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #25628F;
            }
            .match-heading{
                border-bottom: 1px solid #dee0e1;
                padding: 10px;
                min-width:349px;
                font-size: 11px;
            }
            .match-listing{
                padding-left: 0;
                margin-bottom: 0;
                list-style-type: none;
                min-width:349px;
                .match-item{
                    border-bottom: 1px solid #dee0e1;
                    .product-name, .percentage, .show-snapshot{
                        padding: 10px 10px;
                    }
                    .product-name{
                        float: left;
                    }
                    .percentage{
                        float: right;
                    }
                    .show-snapshot{
                        float: right;
                        border-left: 1px solid #dee0e1;
                        i{
                            pointer-events: none;
                        }
                        &.open{
                            i{
                                transform: rotate(180deg);
                            }
                        }
                    }
                    .attribute-match-listing{
                        border-top: 1px solid #dee0e1;
                        background-color: #f5f6fa;
                        ul{
                            list-style-type: none;
                            padding-left: 0;
                            margin-bottom: 0;
                            li{
                                padding: 3px 10px;
                                border-bottom: 1px solid #dee0e1;
                                &:last-child{
                                    border-bottom: 1px solid transparent;
                                }
                            }
                        }
                    }
                }
            }
        }
        &.open{
            transition: height 0.5s;
            height: 365px;
            .form-container{
                transition: width 0.5s,  height 0.5s;
                width: 65%;
                height: 365px;
            }
            .match-container{
                transition: width 0.5s,  height 0.5s;
                width: 35%;
                height: 365px;
                box-shadow: -1px 0px 2px 0px rgba(115, 115, 115, 0.1);
                opacity:1;
            }
            &.match-disabled{
                .form-container{
                    transition: width 0.5s,  height 0.5s;
                    width: 100%;
                    height: 365px;
                }
                .match-container{
                    transition: width 0.5s,  height 0.5s;
                    width: 0%;
                    display: none;
                    height: 365px;
                    box-shadow: none;
                    opacity:0;
                }
            }
        }
    }
    .modal-body{
        transition: height 0.5s;
        padding: 0;
        height: 120px;
    }
    .modal-dialog{
        transition: width 0.5s, max-width 0.5s;
        &.expanded{
            transition: width 0.5s, max-width 0.5s;
            width: 1000px !important;
            max-width: 1000px !important;
        }
    }
    .nested-attribute-child{
        margin-top: -1px;
    }
    .attribute-group-set{
        margin-top: 30px;
        padding-top: 20px;
        border-top: 1px solid #dedede;
    }

    .no-related-found{
        padding: 82px 10px 10px 10px;
        height: 303px;
        text-align: center;
        .icon{
            font-size: 50px;
            color: #dee0e1;
        }
        .copy{
            color: #969696;
        }
    }
    .btn-generate-name{
        margin-top: 27px;
        width:100%;
    }
    @keyframes opacity {
        from { opacity: 0; }
        to   { opacity: 1; }
    }

    .child-attribute{
        padding-left: 25px;
    }
</style>
